import L from 'leaflet'

export const sensorMarkerIcon = (backgroundColor: string, size = 18) => {
  const svgString = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="${backgroundColor}"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
    </svg>
  `

  const encoded = new TextEncoder().encode(svgString)
  const base64 = btoa(String.fromCharCode(...encoded))
  const svgUrl = `data:image/svg+xml;base64,${base64}`

  return L.icon({
    iconUrl: svgUrl,
    iconSize: [size, size],
    iconAnchor: [8, 8],
  })
}

export const alertMarkerIcon = (backgroundColor: string) => {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="${backgroundColor}" 
    stroke="currentColor" 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
    class="lucide lucide-triangle-alert-icon lucide-triangle-alert">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
  `

  const encoded = new TextEncoder().encode(svgString)
  const base64 = btoa(String.fromCharCode(...encoded))
  const svgUrl = `data:image/svg+xml;base64,${base64}`

  return L.icon({
    iconUrl: svgUrl,
    iconSize: [25, 25],
    iconAnchor: [8, 8],
  })
}
